import { styled } from '@linaria/react';

const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 12px 8px 16px;
  border: 1px solid var(--sky-light);
  border-radius: 24px;
  background: var(--sky-lightest);
  transition: border-color 0.2s, box-shadow 0.2s;
  position: relative;
  box-shadow: 0 1px 4px var(--flora-shadow-input);

  &:focus-within {
    border-color: var(--flora-focus-border);
    box-shadow: 0 0 0 2px var(--flora-focus-ring-input);
    background: var(--base-white);
  }
`;

const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TriggerBtn = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: var(--ink-lighter);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: var(--ink-base);
    background: var(--flora-hover-subtle);
  }
`;

const SendButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--flora-send-btn-bg);
  color: var(--base-white);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, opacity 0.15s;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    background: var(--sky-light);
    color: var(--sky-dark);
    cursor: not-allowed;
  }
`;

export { InputBox, SendButton, ToolbarLeft, ToolbarRight, ToolbarRow, TriggerBtn };
